// extracted by mini-css-extract-plugin
module.exports = {"Card":"style_Card__1Y9jl","Btn":"style_Btn__18u5E","Marck":"style_Marck__3epSa","Wrapper":"style_Wrapper__3YRNe","Content":"style_Content__me30U","Avatar":"style_Avatar__1VojC"};